import { Link } from 'react-router'
import PageShell from '../components/PageShell'
import { APP_REGISTER_URL } from '../content/site'
import { STATES } from '../content/states'

export default function CoveragePage() {
  return (
    <PageShell
      title="Coverage"
      intro="ProcurAlerts is a regional product by design: deep coverage of public procurement across the six New England states, instead of thin national coverage."
    >
      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">Six New England states</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7] mb-6">
          We monitor municipal portals, state procurement systems, housing authorities,
          transit agencies, and other public purchasing offices in every New England state.
          You choose the states and counties you work in; alerts are matched to that
          territory. Select a state below to learn more about its coverage.
        </p>
        <ul className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {STATES.map((s) => (
            <li key={s.abbreviation}>
              <Link
                to={`/government-bids/${s.slug}`}
                className="block bg-white/[0.03] border border-white/[0.06] rounded-xl p-5 hover:border-[#06b6d4]/40 transition-colors group"
              >
                <span className="text-xs font-mono uppercase tracking-[0.08em] text-[#06b6d4]">
                  {s.abbreviation}
                </span>
                <h3 className="mt-1 text-base font-semibold text-white group-hover:text-[#22d3ee] transition-colors">
                  {s.name}
                </h3>
                <span className="mt-1 block text-xs text-[#6b7280] group-hover:text-[#9ca3af] transition-colors">
                  View {s.abbreviation} coverage →
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">What sources we monitor</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7] mb-4">
          Coverage includes city and town procurement pages, county and regional
          purchasing, state procurement portals, housing authorities, school districts,
          transit agencies, and public utilities across the region. Source types vary by
          state — some agencies post on their own sites, others on shared platforms.
        </p>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7]">
          Coverage grows continuously, and no aggregator can promise completeness: if a
          specific agency or bid matters to you, confirm it against the issuing agency's
          official postings.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">Work outside New England?</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7]">
          ProcurAlerts currently serves New England only. If your work takes you beyond the
          region, let us know — expansion priorities are driven by contractor demand.
        </p>
      </section>

      <a
        href={APP_REGISTER_URL}
        className="inline-block bg-[#06b6d4] text-[#0d1117] text-sm font-semibold px-6 py-3 rounded-lg hover:bg-[#22d3ee] transition-all duration-200"
      >
        Start your 14-day free trial
      </a>
    </PageShell>
  )
}
